import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { baseURLProd } from '../../api';
import { toast } from 'react-toastify';

const InitialSWOTHook = () => {
    const [marksData, setMarksData] = useState(false)
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    // const [initialSwotDetail, setInitialSwotDetail] = useState("");
    const [formDataValue, setFormDataValue] = useState({
        english: "",
        math: "",
        communication: "",
        goal_clarity: ""
    });

    const userId = localStorage.getItem('userId');

    const toggleModal = () => setShowModal(!showModal);
    const toggleModal2 = () => setShowModal2(!showModal2);

    const navigate = useNavigate();


    const handleInitialSwot = async () => {
        const formData = new FormData();
        formData.append("user_id", userId);

        try {
            const [response1, response2] = await Promise.all([
                fetch(`${baseURLProd}initial-swot-result`, {
                    method: "POST",
                    body: formData,
                }),
                fetch(`${baseURLProd}initial-swot-module`, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams({ user_id: userId })
                })
            ]);

            const data1 = await response1.json();
            const data2 = await response2.json();
            console.log(data1,'dataa',data2)
            navigate(`/initialSWOT`, { state: { initialData1: data1, initialData2: data2 } });

        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();

        if (
            !formDataValue.english ||
            !formDataValue.math ||
            !formDataValue.communication ||
            !formDataValue.goal_clarity
        ) {
            toggleModal2()
            return;
        }

        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("eng_mark", formDataValue.english);
        formData.append("math_mark", formDataValue.math);
        formData.append("communication_mark", formDataValue.communication);
        formData.append("goal_clarity", formDataValue.goal_clarity);

        try {
            const response = await fetch(`${baseURLProd}add-initial-swot`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (data.status === false) {
                toggleModal();
                setShowModal(true);
            } else {
                setMarksData(true);
                toast.success(data.message);
                // handleInitialDetail()
            }
        } catch (error) {
            console.error("Error logging in:", error);
            alert("An error occurred. Please try again later.");
        }
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setFormDataValue((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    return {
        handleInitialSwot, handleSave, marksData, toggleModal, showModal, formDataValue, handleOnChange,
        showModal2, toggleModal2
    }
}

export default InitialSWOTHook
